import { getPlaceDetails } from './maps';
import { getNotificationPrefs, showNotification } from './notifications';

let intervalId = null;
const notifiedPlaces = new Set();

const getFavorites = () => {
  try {
    return JSON.parse(localStorage.getItem('beezy-favorites') || '[]');
  } catch {
    return [];
  }
};

const checkPopularity = async () => {
  const prefs = getNotificationPrefs();
  if (!prefs.enabled) return;

  const favorites = getFavorites();
  if (favorites.length === 0) return;

  for (const place of favorites) {
    if (!place.place_id) continue;

    try {
      const details = await getPlaceDetails(place.place_id);
      const popularity = details.current_popularity;

      if (popularity === null || popularity === undefined) continue;

      if (popularity <= prefs.threshold) {
        if (!notifiedPlaces.has(place.place_id)) {
          notifiedPlaces.add(place.place_id);
          showNotification(`${place.name} is quiet!`, {
            body: `Current occupancy: ${popularity}%. Great time to visit!`,
            tag: `beezy-quiet-${place.place_id}`,
          });
        }
      } else {
        // Reset when popularity rises above threshold
        notifiedPlaces.delete(place.place_id);
      }
    } catch {
      // Skip this place on error
    }
  }
};

export const startPopularityChecker = () => {
  stopPopularityChecker();

  const prefs = getNotificationPrefs();
  if (!prefs.enabled) return;

  const intervalMs = (prefs.intervalMinutes || 15) * 60 * 1000;
  checkPopularity();
  intervalId = setInterval(checkPopularity, intervalMs);
};

export const stopPopularityChecker = () => {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
};
